import $ from 'jquery';
import qs from 'qs';
import differenceInDays from 'date-fns/differenceInDays';
import fastdom from 'fastdom';
import './apartments-filters-form.scss';

const allowedStartAts = [1, 8, 16, 24];

const periodStrings = {
  1: 'Une Semaine',
  2: 'Deux Semaines',
  3: 'Trois Semaines (+1 nuit offerte)',
  4: 'Un Moi (+2 nuits offertes)',
};

$('document').ready(function() {
  if ($('.shortcode-apartments-filters-form').length) {
    startFiltersForm();
  }
});

function IsAvailable(date) {
  const { apartments } = salaktaPlageConfig;
  // get first and last reservation

  let occurrenceCount = 0;
  apartments.map(apartment => {
    let futureReservations = getFutureReservations(apartment);
    futureReservations.map(reservation => {
      if (reservation.start_at <= date && date < reservation.end_at) {
        occurrenceCount++;
      }
    });
  });
  if (occurrenceCount === apartments.length) {
    return false;
  }
  return true;
}
function startFiltersForm() {
  let state = {
    start_at: null,
    period: null,
    rooms: null,
    floor: null,
    facade: null,
    jardin: null,
    terrasse: null,
    barbecue: null,
  };
  const selectors = {
    form: '.shortcode-apartments-filters-form',
    startAt: '.sp-start-at',
    period: '.sp-period',
    rooms: '.sp-rooms',
    floor: '.sp-floor',
    facade: '.sp-facade',
    jardin: '.sp-jardin',
    terrasse: '.sp-terrasse',
    barbecue: '.sp-bbq',
    apartment: '.shortcode-apartments-apartment',
    row: '.shortcode-apartments-row',
    link: '.shortcode-apartments-link',
    togglerButton: '.sp-filters-form-mini-toggler',
    selectedFiltersNotice: '.sp-selectedFiltersNotice',
  };
  loadFormValuesFromQueryArgs();
  registerEvents();

  function loadFormValuesFromQueryArgs() {
    const args = qs.parse(location.search.substr(1));
    const {
      start_at,
      period,
      rooms,
      floor,
      facade,
      jardin,
      terrasse,
      barbecue,
    } = args;
    setState(args);
    if (start_at) {
      $(selectors.startAt).val(start_at);
    }
    if (period) {
      $(selectors.period).val(period);
    }
    if (rooms) {
      $(selectors.rooms).val(rooms);
    }
    if (floor) {
      $(selectors.floor).val(floor);
    }
    if (facade) {
      $(`${selectors.facade} input[value=${facade}]`).prop('checked', true);
    }
    if (jardin) {
      $(`${selectors.jardin} input[value=${jardin}]`).prop('checked', true);
    }
    if (terrasse) {
      $(`${selectors.terrasse} input[value=${terrasse}]`).prop('checked', true);
    }
    if (barbecue) {
      $(`${selectors.barbecue} input[value=${barbecue}]`).prop('checked', true);
    }
  }

  function registerEvents() {
    $(document).click(function(e) {
      if ($(e.target).hasClass('sp-feedback-reset-button')) {
        resetSearch();
      }
    });
    $(selectors.startAt).datepicker({
      dateFormat: 'dd/mm/yy',
      beforeShowDay: function(date) {
        if (differenceInDays(date, new Date()) < 0)
          return [false, 'sp-reservation-date-in-the-past'];
        if (allowedStartAts.indexOf(date.getDate()) === -1) {
          return [false, 'sp-reservation-date-disabled'];
        } else {
          if (!IsAvailable(date)) {
            return [false, 'sp-reservation-date-disabled'];
          }
        }
        return [true];
      },
    });
    $(selectors.togglerButton).on('click', function(e) {
      e.preventDefault();
      $(selectors.form).toggleClass('sp-open sp-closed');
    });
    $(selectors.form).on('submit', function(e) {
      e.preventDefault();
    });
    $(selectors.startAt).on('change input', function() {
      setState({ start_at: $(selectors.startAt).val() });
    });
    ['facade', 'jardin', 'terrasse', 'barbecue'].forEach(function(item) {
      $(`${selectors[item]} input[type=radio]`).on('change', function() {
        setState({
          [item]: $(`${selectors[item]} input[type=radio]:checked`).val(),
        });
      });
    });
    ['period', 'floor', 'rooms'].forEach(function(item) {
      $(selectors[item]).on('change', function() {
        setState({ [item]: $(selectors[item]).val() });
      });
    });
  }

  function setState(newValues) {
    state = { ...state, ...newValues };
    const { pathname } = location;
    const search = qs.stringify(state);
    filterApartments();
    updateApartmentLinks();
    history.replaceState(null, null, `${pathname}?${search}`);
  }

  function boolFromString(string) {
    if (string === 'true') return true;
    if (string === 'false') return false;
  }

  function updateApartmentLinks() {
    $(selectors.link).each(function(index) {
      const href = $(this).prop('href');
      const [url, search] = href.split('?');
      const newSearch = qs.stringify({
        ...qs.parse(search),
        start_at: state.start_at,
        period: state.period,
      });
      $(this).prop('href', `${url}?${newSearch}`);
    });
  }

  function filterApartments() {
    const { apartments } = salaktaPlageConfig;
    let startAtD;
    if (state.start_at) {
      const day = +state.start_at.slice(0, 2);
      const month = +state.start_at.slice(3, 5);
      const year = +state.start_at.slice(6);
      startAtD = new Date(year, month - 1, day);
    }

    const filtered = apartments.filter(function(apartment) {
      if (state.floor && state.floor != apartment.acf.floor) {
        return false;
      }
      if (state.rooms && state.rooms != apartment.acf.rooms) {
        return false;
      }
      if (state.facade && state.facade != apartment.acf.facade) {
        return false;
      }
      if (
        state.terrasse &&
        boolFromString(state.terrasse) !== apartment.acf.terrasse
      ) {
        return false;
      }
      if (
        state.jardin &&
        boolFromString(state.jardin) !== apartment.acf.jardin
      ) {
        return false;
      }
      if (
        state.barbecue &&
        boolFromString(state.barbecue) !== apartment.acf.barbecue
      ) {
        return false;
      }
      // check start at
      if (startAtD) {
        // dates in the past are not accepted
        if (differenceInDays(startAtD, new Date()) < 0) return false;

        const futureReservations = getFutureReservations(apartment);

        let anchor;
        let hasValidStartAt = true;
        var validDiff;
        futureReservations.forEach(function(reservation, index) {
          if (validDiff) return;
          if (!hasValidStartAt) return;
          if (!anchor) {
            anchor = reservation.start_at;
            const diff = differenceInDays(anchor, startAtD);
            if (diff >= 0) {
              if (diff < 7) {
                // before the start at but not enough
                hasValidStartAt = false;
              } else {
                // enough
                validDiff = diff;
              }
            } else {
              // negative && last reservation
              if (index + 1 === futureReservations.length) {
                const diffWithAnchor = differenceInDays(
                  startAtD,
                  reservation.end_at
                );
                if (diffWithAnchor < 0) {
                  hasValidStartAt = false;
                }
              }
            }
          } else {
            const diffWithAnchor = differenceInDays(startAtD, anchor);
            if (diffWithAnchor < 0) {
              hasValidStartAt = false;
            }
            const diffWithNextStartAt = differenceInDays(
              reservation.start_at,
              startAtD
            );
            if (diffWithNextStartAt >= 7) {
              validDiff = diffWithNextStartAt;
            } else {
              if (index + 1 === futureReservations.length) {
                const diffWithAnchor = differenceInDays(
                  startAtD,
                  reservation.end_at
                );
                if (diffWithAnchor < 0) {
                  hasValidStartAt = false;
                }
              }
            }
          }

          anchor = reservation.end_at;
        });
        if (!hasValidStartAt) return false;
      }

      if (state.period) {
        validDiff = validDiff || Infinity;
        const period = +state.period;
        if (period === 1 && validDiff < 7) return false;
        if (period === 2 && validDiff < 14) return false;
        if (period === 3 && validDiff < 22) return false;
        if (period === 4 && validDiff < 30) return false;
      }
      // check period
      return true;
    });
    const allIds = apartments.map(function(item) {
      return item.id;
    });
    const ids = filtered.map(function(item) {
      return item.id;
    });

    fastdom.mutate(function runFastDom() {
      allIds.forEach(function showAndHideApartments(id) {
        if (ids.indexOf(id) !== -1) {
          $(`${selectors.apartment}[data-id=${id}]`).show();
        } else {
          $(`${selectors.apartment}[data-id=${id}]`).hide();
        }
      });
    });

    showNotifier(ids);
  }

  function showNotifier(ids) {
    fastdom.mutate(function displayNotification() {
      let text = "On n'a trouvé aucun resultat pour vous";
      if (ids.length === 1) {
        text = 'On a trouvé <strong>1</strong> appartement';
      } else if (ids.length > 1) {
        text = `On a trouvé <strong>${ids.length}</strong> appartements`;
      }
      const preparedFeedbackMessage = `<h6 class="sp-feedback-title">${text}</h6>`;
      if (!$(`${selectors.row} .sp-feedback`).length) {
        if (ids.length) {
          $(selectors.row).prepend(`<div class="sp-feedback"></div>`);
        } else {
          $(selectors.row).prepend(
            `<div class="sp-feedback sp-feedback-no-results"></div>`
          );
        }
      } else {
        if (ids.length) {
          $(`${selectors.row} .sp-feedback`).removeClass(
            'sp-feedback-no-results'
          );
        } else {
          $(`${selectors.row} .sp-feedback`).addClass('sp-feedback-no-results');
        }
      }

      $(`${selectors.row} .sp-feedback .sp-feedback-title`).remove();
      $(`${selectors.row} .sp-feedback`).prepend(preparedFeedbackMessage);

      const resetButton = `<button type="button" class="sp-feedback-reset-button">Réinitialiser Les Filtres</button>`;
      $(`${selectors.row} .sp-feedback .sp-feedback-reset-button`).remove();
      $(`${selectors.row} .sp-feedback`).append(resetButton);
      try {
        $('.sp-feedback')[0].scrollIntoView({
          behavior: 'smooth',
          block: 'start',
        });
      } catch (e) {}
    });
    setTimeout(() => {
      showSelectedFiltersNotice();
    });
  }

  function showSelectedFiltersNotice() {
    $(selectors.selectedFiltersNotice).remove();
    const wrapperClassName = selectors.selectedFiltersNotice.replace(/\./g, '');

    const wrapper = document.createElement('div');
    wrapper.classList.add(wrapperClassName);

    const singleFilterClass = 'single-filter';
    if (
      !(
        state.start_at ||
        state.period ||
        !['', undefined, null].includes(state.rooms) ||
        !['', undefined, null].includes(state.floor) ||
        !['', undefined, null].includes(state.facade) ||
        !['', undefined, null].includes(state.jardin) ||
        !['', undefined, null].includes(state.terrasse) ||
        !['', undefined, null].includes(state.barbecue)
      )
    ) {
      return;
    }
    const getBoolean = bool => bool === 'true';

    {
      const el = document.createElement('p');
      el.innerHTML = `Liste d'appartements correspondants au filtres:`;
      wrapper.append(el);
    }

    if (state.start_at) {
      const el = document.createElement('div');
      el.classList.add(singleFilterClass);
      el.innerHTML = `<span class="label">Date d'entrée:</span> <span class="value highlight">${state.start_at}</span>`;
      wrapper.append(el);
    }
    if (state.period) {
      const el = document.createElement('div');
      el.classList.add(singleFilterClass);
      el.innerHTML = `<span class="label">Période:</span> <span class="value highlight">${
        periodStrings[state.period]
      }</span>`;
      wrapper.append(el);
    }

    if (!['', undefined, null].includes(state.rooms)) {
      const el = document.createElement('div');
      const map = {
        0: 'S + 1',
        1: 'S + 2',
        2: 'S + 3',
      };
      el.classList.add(singleFilterClass);
      el.innerHTML = `<span class="label">Nombre de Chambres:</span> <span class="value">${
        map[state.rooms]
      }</span>`;
      wrapper.append(el);
    }
    if (!['', undefined, null].includes(state.floor)) {
      const map = {
        0: 'Rez de Chaussé',
        1: '1ère Étage',
        2: '2ème Étage',
        3: '3ème Étage',
      };
      const el = document.createElement('div');
      el.classList.add(singleFilterClass);
      el.innerHTML = `<span class="label">Étage:</span> <span class="value">${
        map[state.floor]
      }</span>`;
      wrapper.append(el);
    }
    if (!['', undefined, null].includes(state.facade)) {
      const el = document.createElement('div');
      el.classList.add(singleFilterClass);
      el.innerHTML = `<span class="label">Façade?:</span> <span class="value">${state.facade}</span>`;
      wrapper.append(el);
    }
    if (!['', undefined, null].includes(state.jardin)) {
      const el = document.createElement('div');
      el.classList.add(singleFilterClass);
      el.innerHTML = `<span class="label">Avec Jardin?:</span> <span class="value">${
        getBoolean(state.jardin) ? 'Avec' : 'Sans'
      }</span>`;
      wrapper.append(el);
    }
    if (!['', undefined, null].includes(state.terrasse)) {
      const el = document.createElement('div');
      el.classList.add(singleFilterClass);
      el.innerHTML = `<span class="label">Avec Terrasse?:</span> <span class="value">${
        getBoolean(state.terrasse) ? 'Avec' : 'Sans'
      }</span>`;
      wrapper.append(el);
    }
    if (!['', undefined, null].includes(state.barbecue)) {
      const el = document.createElement('div');
      el.classList.add(singleFilterClass);
      el.innerHTML = `<span class="label">Avec Barbecue?:</span> <span class="value">${
        getBoolean(state.barbecue) ? 'Avec' : 'Sans'
      }</span>`;
      wrapper.append(el);
    }

    $(wrapper).insertAfter('.sp-feedback');
  }

  function resetSearch() {
    $(selectors.startAt).val(null);
    $(selectors.period).val(null);
    $(selectors.rooms).val(null);
    $(selectors.floor).val(null);
    $(`${selectors.facade} input[value='']`).prop('checked', true);
    $(`${selectors.jardin} input[value='']`).prop('checked', true);
    $(`${selectors.terrasse} input[value='']`).prop('checked', true);
    $(`${selectors.barbecue} input[value='']`).prop('checked', true);
    setState({
      start_at: null,
      period: null,
      rooms: null,
      floor: null,
      facade: null,
      jardin: null,
      terrasse: null,
      barbecue: null,
    });
  }
}

function getFutureReservations({ future_reservations }) {
  return future_reservations
    .map(function(item) {
      const { start_at, end_at } = item;
      const new_start_at = new Date(
        +start_at.slice(0, 4),
        +start_at.slice(4, 6) - 1,
        +start_at.slice(6)
      );
      const new_end_at = new Date(
        +end_at.slice(0, 4),
        +end_at.slice(4, 6) - 1,
        +end_at.slice(6)
      );

      return {
        ...item,
        start_at: new_start_at,
        end_at: new_end_at,
      };
    })
    .sort(function compare(a, b) {
      return a.start_at - b.start_at;
    });
}
